import { useCallback, useState } from "react";

import { DeleteModal } from "src/components/deleteModal";
import { ApiError } from "src/core/apiError";
import { Brig } from "src/gen/rest/brig/BrigService";
import { DeleteUserRequest } from "src/gen/schema/brig/bapi";

interface DeleteBotModalProps {
  readonly botId: string;
  readonly botName: string;
  readonly show: boolean;
  readonly onClose: () => void;
  readonly onSuccess: () => void;
}

export const DeleteBotModal = ({
  botId,
  botName,
  show,
  onClose,
  onSuccess
}: DeleteBotModalProps) => {
  const [error, setError] = useState<ApiError | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  const handleDelete = useCallback(() => {
    setError(undefined);
    setLoading(true);
    Brig.deleteUser(DeleteUserRequest.create({ userId: botId }))
      .then(() => {
        onSuccess();
        onClose();
      })
      .catch(setError)
      .finally(() => {
        setLoading(false);
      });
  }, [botId, onClose, onSuccess]);

  return (
    <DeleteModal
      show={show}
      title="Delete bot user"
      message={
        <>
          Are you sure you want to delete bot user <strong>{botName}</strong>?
        </>
      }
      onCancel={onClose}
      onDelete={handleDelete}
      deleteText="Delete"
      error={error?.getMessage()}
      disabled={loading}
    />
  );
};
